import React from 'react';
import { useAuth } from 'hooks';
import licenseType from 'models/licenseType';
import {
  SuggestionsGrid,
  SuggestionSection,
  SectionTitle,
  SuggestionPillsContainer,
  ExampleChip,
} from './styled';
import { orgProfileExampleQueries, orgProfileAdvancedQueries } from './strings';

/**
 * Example/advanced queries shown as NON-clickable guidance in the org profile
 * modal — results aren't guaranteed within a single organisation, so these are
 * inspiration for what to ask, not canned searches. Content varies by licence:
 * BioPharma set for industry-licensed users (dual-licence included), Academic
 * set otherwise. Trials see the same set as their full-licence equivalent.
 */
export function NLPOrgGuidanceQueries() {
  const { hasLicense } = useAuth();
  const licenceKey = hasLicense([licenseType.industry], true)
    ? 'industry'
    : 'academic';

  return (
    <SuggestionsGrid data-testid='nlp-org-guidance'>
      <SuggestionSection>
        <SectionTitle>Example Searches</SectionTitle>
        <GuidancePills prompts={orgProfileExampleQueries[licenceKey]} />
      </SuggestionSection>
      <SuggestionSection>
        <SectionTitle>Advanced Use Cases</SectionTitle>
        <GuidancePills prompts={orgProfileAdvancedQueries[licenceKey]} />
      </SuggestionSection>
    </SuggestionsGrid>
  );
}

function GuidancePills({ prompts }) {
  return (
    <SuggestionPillsContainer>
      {prompts.map(prompt => (
        <ExampleChip key={prompt} data-testid={`nlp-guidance-${prompt}`}>
          {prompt}
        </ExampleChip>
      ))}
    </SuggestionPillsContainer>
  );
}
